import { AxiosInstance } from 'axios'
import {
  FboWalletPayload,
  UnitActiveCustomer,
  UnitApplicationFormStatus,
  UnitApplicationType,
  UnitCounterPartyAccount,
  UnitCounterPartyManualAccountPayload,
  UnitPlaidAccountPayload,
  UnitScopes
} from 'types/unit'
import { UNIT_ENDPOINTS } from 'api/ApiRoutes'
import { ID } from 'types/utility'

class UnitApi {
  constructor(private axiosInstance: AxiosInstance) {}

  unitCreateApplicationForm = async ({
    applicationType
  }: {
    applicationType: UnitApplicationType
  }) => {
    const payload = {
      application_form: {
        application_type: applicationType
      }
    }
    const d = await this.axiosInstance.post<UnitApplicationFormStatus>(
      UNIT_ENDPOINTS.BASE,
      payload
    )
    return d.data
  }

  unitGetTeamActiveApplicationForm = async ({
    team_token_id
  }: {
    team_token_id: ID
  }) => {
    const d = await this.axiosInstance.get<UnitApplicationFormStatus>(
      UNIT_ENDPOINTS.ACTIVE_APPLICATION_FORM(team_token_id)
    )
    return d.data
  }

  unitGetCurrentUserActiveCustomer = (includeBalance = false) => {
    return this.axiosInstance
      .get<UnitActiveCustomer>(
        `${UNIT_ENDPOINTS.ACTIVE_UNIT_CUSTOMER}?include_balance=${includeBalance}`
      )
      .then((d) => d.data)
  }

  unitGetTeamCustomer = async ({
    team_token_id,
    ...params
  }: {
    team_token_id: ID
    scope?: UnitScopes
    verification_code?: string
    verification_token?: string
  }) => {
    const urlSearchParams = new URLSearchParams(params)
    const d = await this.axiosInstance.get<UnitActiveCustomer>(
      `${UNIT_ENDPOINTS.TEAM_UNIT_CUSTOMER(team_token_id)}?${urlSearchParams.toString()}`
    )
    return d.data
  }

  unitAddCounterPartyAccount = async (
    payload: UnitCounterPartyManualAccountPayload | UnitPlaidAccountPayload
  ) => {
    const d = await this.axiosInstance.post<UnitCounterPartyAccount>(
      UNIT_ENDPOINTS.COUNTER_PARTY_ACCOUNTS,
      payload
    )
    return d.data
  }

  unitGetCounterPartyAccount = async (tokenId: string) => {
    const d = await this.axiosInstance.get<UnitCounterPartyAccount>(
      UNIT_ENDPOINTS.COUNTER_PARTY_ACCOUNT(tokenId)
    )
    return d.data
  }

  createFboWallet = async (payload: FboWalletPayload) => {
    const d = await this.axiosInstance.post(
      UNIT_ENDPOINTS.UNIT_ACCOUNTS,
      payload
    )
    return d.data
  }
}

export default UnitApi
